module.exports = __webpack_public_path__ + "assets/img/Electric_1.840a9aae.png";